import React, { useEffect, useState } from "react";
import "./Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faPinterest,
  faInstagram,
  faYoutube,
  faStumbleupon,
  faDribbble,
  faFacebookF,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import {
  Form,
  InputGroup,
  ListGroup,
  Nav,
  Navbar,
  Offcanvas,
} from "react-bootstrap";
import {
  faBagShopping,
  faBars,
  faBell,
  faBoxOpen,
  faCartShopping,
  faHeart,
  faLock,
  faMagnifyingGlass,
  faPhone,
  faRightFromBracket,
  faShieldHalved,
  faSortDown,
  faUser,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import Login_Modal from "../common_components/common_modal/login_modal/Login_Modal";
import Reset_Password_Modal from "../common_components/common_modal/reset_password_modal/Reset_Password_Modal";
import Set_New_Password_Modal from "../common_components/common_modal/set_new_password_modal/Set_New_Password_Modal";
import Use_Current_Location from "../common_components/common_modal/Use_Current_Location/Use_Current_Location";
import Confirm_Location_modal from "../common_components/common_modal/Confirm_Location_modal/Confirm_Location_modal";
import Delete_Contact_Modal from "../common_components/common_modal/delete_contact_modal/Delete_Contact_Modal";
import { getAllCart, postToLoginCart } from "../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { setIsSignedOut } from "../../features/auth/authSlice";
import { getAllWishlist } from "../../features/wishlist/wishlistSlice";
import { getNotifications } from "../../features/notifications/notificationSlice";
import {
  getAllCountriesByName,
  getCityByName,
  getLocationFromSession,
} from "../../features/location/locationSlice";
import Cookies from "js-cookie";
import { appSetup } from "../../features/master/masterSlice";
import { contactusForm } from "../../features/contact_us/contactusSlice";
import {
  getAllProducts,
  PostSearchHistory,
} from "../../features/products/productsSlice";

function Header() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [searchoffcanvas, setSearchOffcanvas] = useState(false);
  const [showLogoutModal, setshowLogoutModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [showSetPassModal, setShowSetPassModal] = useState(false);
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showAccountCreted, setShowAccountCreted] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [showConfimLocModal, setShowConfimLocModal] = useState(false);
  const [logOutoffcanvas, setLogOutOffcanvas] = useState(false);
  const [isLogedIn, setIsLogedIn] = useState(false);

  const [email, setEmail] = useState();
  const [contact, setContact] = useState();

  const isSignIn = useSelector((state) => state.auth.is_signin);
  const allCarts = useSelector((state) => state.cart.allCarts);
  const dispatch = useDispatch();

  const goToNotificationsTab = () => {
    navigate("/my-profile", { state: { selectedTab: "third" } });
  };

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/category", label: "Category" },
    // { path: "/category", label: "Shop" },
    { path: "/blog", label: "Blogs" },
    { path: "/contact-us", label: "Contact Us" },
    // { path: "/career", label: "Career" },
  ];

  const isActive = (path) => currentPath === path;

  const handleNavClick = (path) => {
    navigate(path);
    handleClose();
  };

  const [showOffcanvas, setShowOffCanvas] = useState(false);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [searchToggled, setIsToggled] = useState(false);

  const toggleClick = () => {
    setIsToggled((prevState) => !prevState);
  };

  const [showHeader, setShowHeader] = useState(false);

  useEffect(() => {
    if (isSignIn) {
      setIsLogedIn(true);
    }
    const handleScroll = () => {
      setShowHeader(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isSignIn]);

  const navigate = useNavigate();

  const [showModals, setShowModals] = useState({
    chooseLocation: false,
    confirmLocation: false,
    selectCountry: false,
    selectLocation: false,
  });

  const allWishlist = useSelector((state) => state.wishlist.allWishlist);
  const user = useSelector((state) => state.myaccount.addMyaccount);
  useEffect(() => {
    if (user?.id) {
      dispatch(getAllWishlist());
    }
  }, []);

  const notifications = useSelector(
    (state) => state.notification.notifications
  );

  useEffect(() => {
    // if (user?.id) {
    dispatch(getNotifications());
    // }
  }, []);

  const isActivepath = location.pathname;

  const toggleModal = (modal) =>
    setShowModals((prev) => ({ ...prev, [modal]: !prev[modal] }));

  // const login = false //login status---------------------------------------------------------------------------------------------
  useEffect(() => {
    const loginCart = async () => {
      if (isSignIn) {
        const res = await dispatch(postToLoginCart());
        if (res.meta?.requestStatus === "fulfilled") {
        } else if (res.meta?.requestStatus === "rejected") {
          console.log("Error:", res.payload || "Login Cart Post Failed");
        }
      }
      await dispatch(getAllCart(isSignIn));
    };

    loginCart();
  }, [isSignIn]);

  const handleCloseLogout = async () => {
    setshowLogoutModal(true);

    navigate("/");
  };

  const current_location = useSelector(
    (state) => state.location.current_location
  );
  // useEffect(() => {
  //   dispatch(getAllCountriesByName(current_location?.country));
  //   dispatch(getCityByName(current_location?.city));
  // }, [current_location]);

  useEffect(() => {
    dispatch(getLocationFromSession());
  }, [dispatch]);

  useEffect(() => {
    // Show the modal when the component mounts
    const current_location = Cookies.get("current_location_grocido");
    if (!current_location) {
      setSearchOffcanvas(true);
    }
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && searchTerm.trim() !== "") {
      navigate(`/category?search=${encodeURIComponent(searchTerm)}`);
    }
  };

  const allProducts = useSelector((state) => state.product.allProducts);
  useEffect(() => {
    dispatch(
      getAllProducts({
        name: searchTerm,
      })
    );
  }, [dispatch, searchTerm]);

  const handleSearchClick = async () => {
    const data = {
      name: searchTerm,
    };
    await dispatch(PostSearchHistory(data));
    await dispatch(
      getAllProducts({
        name: searchTerm,
      })
    );

    if (searchTerm.trim() !== "") {
      navigate(`/all-product`, {
        state: { data: allProducts, headingText: "All Product" },
      });
    }
  };

  const app_setup = useSelector((state) => state.master.app_setup);
  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  const socialLink = useSelector((state) => state.socialmedia.addSocialmedia);

  return (
    <>
      <section className="Header">
        <div className="top_headers_holder">
          <div className="top_header">
            <div className="container">
              <div className="top_header_bar thnk_col_2">
                {/* <div className="top_header_col1">
                  <div className="content_html">WELCOME TO Chef Cuts</div>
                </div> */}
                <div className="top_header_col2">
                  <div className="content_social">
                    <ul className="social_icon">
                      {socialLink?.map((item) => {
                        return (
                          <li onClick={() => window.open(item?.url, "_blank")}>
                            {/* <FontAwesomeIcon
                          icon={faLinkedinIn}
                          className="icons"
                        /> */}
                            <img
                              src={process.env.REACT_APP_IMG_URL + item?.image}
                              className="icons"
                            />
                          </li>
                        );
                      })}

                      {/* <li
                        onClick={() =>
                          window.open("https://www.facebook.com", "_blank")
                        }
                      >
                        <FontAwesomeIcon icon={faFacebookF} className="icons" />
                      </li>
                      <li
                        onClick={() =>
                          window.open("https://twitter.com", "_blank")
                        }
                      >
                        <FontAwesomeIcon icon={faXTwitter} className="icons" />
                      </li>
                      <li
                        onClick={() =>
                          window.open("https://www.instagram.com", "_blank")
                        }
                      >
                        <FontAwesomeIcon icon={faInstagram} className="icons" />
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="middle_header">
            <div className="container">
              <div className="all_divs_holder">
                <div
                  className="logo_div "
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  <img
                    src="/assets/images/header/header_logo2.png"
                    className="logo_img"
                  />
                </div>

                <div className="search_input_div">
                  <InputGroup>
                    <Form.Control
                      placeholder="Search Product"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onKeyDown={handleKeyPress}
                      aria-label="Search Product"
                      aria-describedby="basic-addon2"
                    />
                    <InputGroup.Text
                      id="basic-addon2"
                      onClick={handleSearchClick}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        className="search_icon"
                      />
                    </InputGroup.Text>
                  </InputGroup>
                </div>

                <div className="three_box_div ">
                  <div
                    className="box_div address_box"
                    onClick={() => setSearchOffcanvas(true)}
                  >
                    <p className="title_text">
                      My Location{" "}
                      <FontAwesomeIcon
                        icon={faSortDown}
                        className="inner_icon"
                      />
                    </p>
                    <p className="sub_text">
                      <span className="title_span address_text">
                        {current_location?.formatted_address}
                      </span>
                    </p>
                  </div>

                  {!isLogedIn && (
                    <>
                      <div className="box_div border_box">
                        <p className="title_text">My Cart</p>
                        <p
                          className="sub_text"
                          onClick={() => {
                            navigate("/cart");
                          }}
                        >
                          <span className="title_span"></span>{" "}
                          <FontAwesomeIcon
                            icon={faCartShopping}
                            className={`common_icon ${
                              isActivepath === "/cart" ? "active" : ""
                            }`}
                          />
                        </p>
                      </div>
                      <div className="box_div border_box login_box">
                        <p className="title_text">Login / Signup</p>
                        <p
                          className="sub_text"
                          onClick={() => {
                            setShowLoginModal(true);
                          }}
                        >
                          <span className="title_span">My account</span>{" "}
                          <FontAwesomeIcon
                            icon={faUser}
                            className="common_icon"
                          />
                        </p>
                      </div>
                    </>
                  )}

                  {isLogedIn && (
                    <>
                      <div className="box_div border_box">
                        <p className="title_text">My Cart</p>
                        <p
                          className="sub_text"
                          onClick={() => {
                            navigate("/cart");
                          }}
                        >
                          <span className="title_span"></span>{" "}
                          <FontAwesomeIcon
                            icon={faCartShopping}
                            className={`common_icon ${
                              isActivepath === "/cart" ? "active" : ""
                            }`}
                          />
                        </p>
                      </div>

                      <div className="box_div">
                        <p className="title_text">My Favourite</p>
                        <p
                          className="sub_text count_text_holder"
                          onClick={() => {
                            navigate("/wishlist");
                          }}
                        >
                          <span className="title_span"></span>{" "}
                          <FontAwesomeIcon
                            icon={faHeart}
                            className={`common_icon ${
                              isActivepath === "/wishlist" ? "active" : ""
                            }`}
                          />
                          {allWishlist?.data?.length > 0 && (
                            <div className="count_holder">
                              {allWishlist?.data?.length}
                            </div>
                          )}
                        </p>
                      </div>

                      <div className="box_div">
                        <p className="title_text">My wallet</p>
                        <p
                          className="sub_text"
                          onClick={() => {
                            navigate("/my-wallet");
                          }}
                        >
                          <span className="title_span"></span>{" "}
                          <FontAwesomeIcon
                            icon={faWallet}
                            className={`common_icon ${
                              isActivepath === "/my-wallet" ? "active" : ""
                            }`}
                          />
                        </p>
                      </div>

                      <div className="box_div">
                        <p className="title_text">Notification</p>
                        <p
                          className={`sub_text  count_text_holder ${
                            notifications?.length > 0 ? `bell_icon_holder` : ``
                          }`}
                          onClick={goToNotificationsTab}
                        >
                          <FontAwesomeIcon
                            icon={faBell}
                            className={`common_icon  ${
                              isActivepath === "" ? "active_class" : ""
                            }`}
                          />
                          {notifications?.filter((n) => n.status === true)
                            ?.length > 0 && (
                            <div className="count_holder">
                              {notifications?.filter((n) => n.status === true)
                                ?.length > 0 &&
                                notifications.filter((n) => n.status === true)
                                  .length}
                            </div>
                          )}
                        </p>
                      </div>

                      {/* <div className="box_div right_box">
                        <div className="big_img_holder" onClick={() => { navigate("/my-wallet") }}>
                          <FontAwesomeIcon icon={faWallet} className={`big_icon ${isActivepath === "/my-wallet" ? "active" : ""}`} />
                        </div>
                        <div className="big_img_holder bell_icon_holder"  onClick={goToNotificationsTab}>
                          <FontAwesomeIcon icon={faBell} className={`big_icon ${isActivepath === "" ? "active_class" : ""}`} />
                        </div>
                      </div> */}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bottom_header">
          <div className="container">
            <div className="two_box_holder">
              <div className="box1">
                <div className="category_manu_div"></div>

                <Navbar expand="lg">
                  {/* <div className="category_div">
                    <Category_Dropdown />
                  </div> */}

                  <div className="menu_toggle">
                    <button onClick={handleShow}>
                      <FontAwesomeIcon icon={faBars} className="menu_icon" />
                      MENU
                    </button>
                  </div>

                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                      {navLinks.map((link) => (
                        <Nav.Link
                          key={link.path}
                          as={Link}
                          to={link.path}
                          active={isActive(link.path)}
                        >
                          {link.label}
                        </Nav.Link>
                      ))}
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
              </div>
              <div className="box2">
                <div className="common_icon_holder">
                  <FontAwesomeIcon icon={faPhone} className="call_icon" />
                </div>
                <div className="text_holder">
                  <p className="first_text">Call To</p>
                  <p className="number_text">+91 {app_setup?.contact_no}</p>
                </div>

                {isLogedIn && (
                  <Dropdown align="end" className="profile_dropdown">
                    <Dropdown.Toggle
                      variant="link"
                      bsPrefix="p-0 border-0 bg-transparent"
                    >
                      <div className="common_icon_holder profile_icon_holder">
                        <FontAwesomeIcon icon={faUser} className="call_icon" />
                      </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <div className="white_box">
                        <Dropdown.Item href="/my-profile">
                          <FontAwesomeIcon icon={faUser} className="icon" />{" "}
                          Profile
                        </Dropdown.Item>
                        <Dropdown.Item href="/my-orders">
                          <FontAwesomeIcon icon={faBoxOpen} className="icon" />{" "}
                          My Orders
                        </Dropdown.Item>
                        <Dropdown.Item href="/change-password">
                          <FontAwesomeIcon
                            icon={faShieldHalved}
                            className="icon"
                          />{" "}
                          Change Password
                        </Dropdown.Item>
                      </div>
                      <Dropdown.Item
                        className="logout_item"
                        onClick={() => setLogOutOffcanvas(true)}
                      >
                        <FontAwesomeIcon
                          icon={faRightFromBracket}
                          className="icon"
                        />{" "}
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
          </div>
        </div>

        <Offcanvas show={show} onHide={handleClose} className="menu_offcanvas">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title></Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Navbar expand="lg">
              <Nav className="me-auto">
                {navLinks.map((link) => (
                  <Nav.Link
                    key={link.path}
                    as={Link}
                    to={link.path}
                    active={isActive(link.path)}
                    onClick={handleClose}
                  >
                    {link.label}
                  </Nav.Link>
                ))}
              </Nav>
            </Navbar>
          </Offcanvas.Body>
        </Offcanvas>

        {currentPath !== "/order-success" && (
          <Use_Current_Location
            show={searchoffcanvas}
            onHide={() => setSearchOffcanvas(false)}
            setShowConfimLocModal={setShowConfimLocModal}
          />
        )}

        <Delete_Contact_Modal
          isSignIn={isSignIn}
          modal_title="Log Out"
          message="Are you sure, you want to Log Out?"
          // show={showLogoutModal}
          onHide={() => {
            setLogOutOffcanvas(false);
          }}
          yesAction={() => {
            setIsLogedIn(false);
          }}
          noAction={() => {
            setLogOutOffcanvas(false);
          }}
          show={logOutoffcanvas}
          // onHide={() => setLogOutOffcanvas(false)}
        />

        {/* <Confirm_Location_modal
          show={showModals.confirmLocation}
          onHide={() => toggleModal("confirmLocation")}
          modalTitle="Your Location Info"
          green_btn_text={"Change Country"}
          orange_btn_text={"Change Location"}
          onBackToChooseLocation={() => {
            toggleModal("confirmLocation");
            toggleModal("chooseLocation");
          }}
          onOpenSelectCountry={() => {
            toggleModal("confirmLocation");
            toggleModal("selectCountry");
          }}

        /> */}

        <Login_Modal
          show={showLoginModal}
          onHide={() => {
            setShowLoginModal(false);
          }}
          loginDone={() => {
            setIsLogedIn(true);
          }}
          setShowResetModal={() => setShowResetModal(true)}
          setShowAccountCreted={() => setShowAccountCreted(true)}
        />

        <Reset_Password_Modal
          email={email}
          setEmail={setEmail}
          contact={contact}
          setContact={setContact}
          show={showResetModal}
          onHide={() => {
            setShowResetModal(false);
          }}
          setShowSetPassModal={() => setShowSetPassModal(true)}
        />

        <Set_New_Password_Modal
          email={email}
          setEmail={setEmail}
          contact={contact}
          setContact={setContact}
          show={showSetPassModal}
          onHide={() => {
            setShowSetPassModal(false);
          }}
          setShowSucsessModal={() => setShowSucsessModal(true)}
        />
      </section>
    </>
  );
}

export default Header;
